// The update wave an endpoint is placed in for the agent's current release,
// as one field beside its agent version. The schedule, the waves and the
// release history live on the central rollout page (Settings / Artifact
// Rollouts), which the field links to for a reader who can open it.
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getEndpointUpdateRollout } from "../../lib/artifactRolloutClient.js";
import { DetailField } from "../detailPrimitives.jsx";

const TRACK = { general: "General rollout", tenant_main: "Main track", tenant_preview: "Preview track", tenant_target: "Targeted rollout" };

export function waveText(data) {
  const release = data?.releases?.[0];
  if (!release) return "Not placed";
  const track = TRACK[release.audience] || release.audience || "";
  return [release.endpointWave ? `Wave ${release.endpointWave}` : "No wave", track].filter(Boolean).join(" · ");
}

export default function EndpointUpdateWave({ endpointId, canOpenRollouts = false }) {
  const [state, setState] = useState({ status: "loading", data: null });
  const [, setParams] = useSearchParams();
  useEffect(() => {
    let live = true;
    setState({ status: "loading", data: null });
    getEndpointUpdateRollout(endpointId)
      .then((data) => { if (live) setState({ status: "done", data }); })
      .catch(() => { if (live) setState({ status: "error", data: null }); });
    return () => { live = false; };
  }, [endpointId]);
  const text = state.status === "loading" ? "Reading..." : state.status === "error" ? "Unavailable" : waveText(state.data);
  const open = () => setParams((p) => {
    const next = new URLSearchParams(p);
    for (const k of ["fleetSelected", "fleetView", "selected", "view"]) next.delete(k);
    next.set("mode", "settings");
    next.set("setting", "endpoints/updates");
    next.delete("adminView");
    return next;
  });
  return (
    <DetailField
      label="Update wave"
      value={(
        <span className="flex flex-wrap items-baseline gap-x-[8px]" data-endpoint-update-wave="">
          <span>{text}</span>
          {canOpenRollouts ? <button type="button" onClick={open} className="text-[11px] text-[color:var(--green)] hover:underline">Ringed updates</button> : null}
        </span>
      )}
    />
  );
}
